<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <h1 class="text-center">VIDEO GAMES</h1>
            </div>

            <div v-for="(game, gameIndex) in games" :key="gameIndex" class="animation col-xs-12">
                <!-- Carousel container -->
                <div :id="`my-pics${gameIndex}`" class="carousel slide" data-ride="carousel">
                    <!-- Indicators -->
                    <ol v-if="game.totalImages > 1" class="carousel-indicators">
                        <li v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" :data-target="`#my-pics${gameIndex}`" :data-slide-to="imageIndex"
                            :class="{ active: imageIndex == 0 }"></li>
                    </ol>

                    <!-- Content -->
                    <div class="carousel-inner" role="listbox">
                        <!-- Slides -->
                        <div v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" class="item" :class="{ active: imageIndex == 0 }">
                            <img :src="require(`@/assets/gallery/video-games/${game.imageFolder}/${number}.webp`)" alt="" />
                        </div>
                    </div>

                    <!-- Previous/Next controls -->
                    <template v-if="game.totalImages > 1">
                        <a class="left carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="prev">
                            <span class="icon-prev" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="right carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="next">
                            <span class="icon-next" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </template>
                </div>
                <div class="desc">
                    <h2>{{ game.title }}</h2>
                    <p v-html="game.desc"></p>
                    <a v-if="game.downloadLink" class="btn btn-default download-btn" :href="game.downloadLink" target="_blank" role="button">Store page</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    //Slide show (bootstrap 3 carousel) link:
    //https://www.quackit.com/bootstrap/bootstrap_3/tutorial/bootstrap_carousel.cfm
    data(){
        return {
            games: [
                {
                    title: 'Mystic Cube - 3D Platformer',
                    desc: 
                        `After your journey in the Material Realm had come to an end, 
                        it is time to go home to the Spirit Dimension. But in order to do so, 
                        you need to get and pass through The Dimensional Portal 
                        that separates these two worlds.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'mc',
                        totalImages: 2,
                        downloadLink: 'https://aleksray.itch.io/mc',
                },
                {
                    title: 'Mystic sphere beyond - 3D Fantasy RPG',
                    desc: 
                        `THE GRAND WAR BEGAN IN THE SPIRIT DIMENSION between the Pure Light
                        and the Corrupted Spirits. You are one of the Seven commanders of
                        the light spirits fighting in the war. But the corrupted spirits
                        opened a portal to another dimension and pulled you in it. Now you
                        are on a mission to find your way back. And so, your journey
                        begins…
                        <br /><br />
                        Made using Unity (C#) and Photoshop.`,
                        imageFolder: 'msb',
                        totalImages: 9,   
                        downloadLink: null,
                },
                {
                    title: 'Roll Ball - 3D Arcade',
                    desc: 
                        `You are a rolling ball in a fenced area and you need to 
                        collect all the yellow crystals in order to win.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'roll-ball',
                        totalImages: 2,   
                        downloadLink: null,
                },
                {
                    title: 'PyraJump - 2D Endless hyper - casual game',
                    desc: 
                        `The player is a sphere that jumps while moving forward and speeds up with time.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'pyra-jump',
                        totalImages: 2,   
                        downloadLink: null,
                },
                {
                    title: 'Cube Run - 2D Platformer',
                    desc: 
                        `The player is a Cube that jumps on platforms 
                        while moving forward to reach the finish line.
                        <br /><br />
                        Made using Unity (C#).`,
                        imageFolder: 'cube-run',
                        totalImages: 1,   
                        downloadLink: null,
                },
                {
                    title: 'Memory game - 2D 4x4 matching game',
                    desc: 
                        `Match all the pairs of images to win.
                        <br /><br />
                        Made with Windows Forms (.NET Framework) in Visual Studio with C#.`,
                        imageFolder: 'memory-game',
                        totalImages: 1,   
                        downloadLink: 'https://aleksray.itch.io/memory-game',
                },
                {
                    title: 'The Forest Hero - 2D fantasy adventure RPG',
                    desc: 
                        `This is the first video game that I created which I named 'The Forest Hero'. 
                        It is about a warrior (his name is not yet revealed) who is in a mystical forest 
                        and has the task of liberating the forest from the evil intruder named Zaros. 
                        The forest gives the necessary help to the warrior to beat the intruder. 
                        But in the meantime, the warrior gets to know himself better, his true nature, 
                        and he unlocks one of his hidden powers that will be decisive in the 
                        final struggle with Zaros.
                        <br /><br />
                        Made using Adobe Flash, Pixel Art and Photoshop.`,
                        imageFolder: 'forest-hero',
                        totalImages: 7,   
                        downloadLink: null,
                },
                //forest hero
            ]
        }
    }
}
</script>

<style scoped>
.container {
    color: white;
    margin-bottom: 50px;
    padding: 20px;
}

h1 {
    /*text-shadow: 0px 0px 2px crimson;*/
    margin-bottom: 40px;
    color: #d33232;
}

p {
    margin-top: 5px;
    text-align: justify;
    font-size: 18px;
}

.animation {
    background-color: #451111;
    border: 1px solid #ad2a2a;
    border-radius: 4px;
    box-shadow: 0px 0px 5px #ad2a2a;
    padding: 1px;
    margin-bottom: 70px;
}

.desc {
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border: 2px solid #ad2a2a;
    border-radius: 4px;
}

.download-btn {
    background-color: #ad2a2a;
    border: 2px solid white;
    border-radius: 4px;
    box-shadow: 0px 0px 5px white;
    margin-bottom: 10px;
    color: white;
    font-size: 16px;
}

.download-btn:hover {
    background-color: white;
    color: #ad2a2a;
    border: 2px solid #ad2a2a;
}

@media screen and (min-width: 992px) {
    .container {
        padding-left: 200px;
        padding-right: 200px;
    }
}

section {
    /*background-color: #111845;*/
    min-height: 100vh;
}
</style>
